import {
  Avatar,
  AvatarGroup,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";

export type TableDataProps = {
  data: {
    head: any[];
    body: any[][];
    options?: {
      avatars?: {
        column_index: number;
        class: string;
      };
    };
  };
};

export const TableData = (props: TableDataProps) => {
  const { data } = props;

  return (
    <Table
      size="medium"
      sx={{
        th: {
          fontWeight: "bold",
          fontSize: "2.2em",
        },

        td: {
          fontSize: "2em",
        },

        "& tr:last-child td": {
          borderBottom: "none",
        },
      }}
    >
      <TableHead>
        <TableRow>
          {data.options?.avatars && <TableCell></TableCell>}
          {data.head.map((row, index) => {
            return <TableCell>{row}</TableCell>;
          })}
        </TableRow>
      </TableHead>

      <TableBody>
        {data.body.map((row, index) => {
          return (
            <TableRow hover key={`data-${index}`}>
              {data.options?.avatars && (
                <TableCell>
                  <AvatarGroup>
                    {row[data.options.avatars.column_index]
                      .split("&")
                      .map((avatar: string) => (
                        <Avatar
                          src={`./class/${
                            data.options?.avatars?.class
                          }/${avatar.trim()}.jpeg`}
                        >
                          {avatar}
                        </Avatar>
                      ))}
                  </AvatarGroup>
                </TableCell>
              )}

              {row.map((col, index2) => {
                return <TableCell>{col}</TableCell>;
              })}
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};
